import { render } from "./Archive.vue?vue&type=template&id=4ff4bbb7&scoped=true"
const script = {}

import "./Archive.vue?vue&type=style&index=0&id=4ff4bbb7&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff4bbb7"]])

export default __exports__